import { useEffect, useState } from 'react';
import { get, post } from '../../Services/api';
import './AdminMeals.css'
import AdminIndividualMeal from './IndividualMeal/IndividualMeal';
import loading_display from '../../Utility/loading_display';
import SelectedMealModal from './SelectedMealModal/SelectedMealModal';
import { Tooltip } from 'react-tooltip';

function AdminMeals({ user_data }) {
    const [meal, setMeal] = useState()
    const [meals, setMeals] = useState()
    const [filter, setFilter] = useState('all')
    const [filterCuisine, setFilterCuisine] = useState()
    const [cuisines, setCuisines] = useState()
    const [page, setPage] = useState(1)
    const [selectedMeals, setSelectedMeals] = useState([])
    const [mealsSelectedAction, setMealsSelectedAction] = useState(false)
    const [search, setSearch] = useState('')

    useEffect(() => {
        // get cuisines
        getAllCuisines()
    }, [])

    useEffect(() => {
        // get meals
        getAllMeals()
    }, [filter, filterCuisine, search, page])

    async function getAllCuisines() {
        try {
            const cuisines = await get("/api/meal/get-all-cuisines")
            setCuisines(cuisines)
        } catch {
            console.log("Error getting the cuisines")
        }
    }

    function getConditions() {
        let condition = ''
        switch (filter) {
            case 'all':
                condition = 'AND 1=1'
                break;
            case 'active':
                condition = 'AND m.is_active = TRUE'
                break;
            case 'inactive':
                condition = 'AND m.is_active = FALSE'
                break;
            case 'subscribers':
                condition = 'AND m.subscribers_only = TRUE'
                break;
            default:
                break;
        }
        if (filterCuisine && filterCuisine != '-All-')
            condition += ' AND ' + filterCuisine + ' = cuisine_id.cuisine_id'

        return condition
    }

    async function getAllMeals() {
        const condition = getConditions()

        // page number limit offset
        const offset = 10 * (page - 1)

        if (search) {
            // if search
            try {
                const response = await post('/api/admin/meal/get-all-meals?offset=' + offset, { search: search })
                setMeals(response ? response : [])
            } catch (error) {
                console.log(error)
            }
        } else if (filter == 'needs attention') {
            try {
                const response = await get('/api/admin/meal/get-meals-needing-review?offset=' + offset + ((filterCuisine && filterCuisine != '-All-') ? ('&cuisine=' + filterCuisine) : ''))

                setMeals(response ? response : [])
            } catch (error) {
                console.log('error getting attention needed meals')
            }
        } else {
            const response = await post('/api/admin/meal/get-all-meals?condition=' + condition + '&offset=' + offset)

            if (response)
                setMeals(response)
            else
                setMeals([])
        }
    }

    async function mealClicked(meal_id) {
        try {
            const response = await get('/api/meal/get-meal-detail?meal_id=' + meal_id + '&user_id=' + user_data.uid)
            if (response)
                setMeal(response)
        } catch (error) {
            console.log(error)
        }
    }

    async function setActiveStatus(meal_id, status) {
        loading_display(true)
        // set activate status
        const result = await post('/api/admin/meal/set-meal-active-flag?is_active=' + status + '&meal_id=' + meal_id)
        loading_display(false)
        // get meal detail again
        getAllMeals()
    }

    async function setSubStatus(meal_id, status) {
        loading_display(true)
        // set subscriber status
        const result = await post('/api/admin/meal/set-meal-sub-flag?subscribers_only=' + status + '&meal_id=' + meal_id)
        loading_display(false)
        // get meal detail again
        getAllMeals()
    }

    function selectedMealFunc(meal_tmp, status) {
        if (status)
            // Add meal to array if checked and it doesn't already exist
            setSelectedMeals((prevMeals) => {
                const exists = prevMeals.some((meal) => meal.meal_id === meal_tmp.meal_id);
                return exists ? prevMeals : [...prevMeals, meal_tmp];
            });
        else
            // Remove meal from array if unchecked
            setSelectedMeals((prevMeals) =>
                prevMeals.filter((meal) => meal.meal_id !== meal_tmp.meal_id)
            );
    }

    function selectedAllMealFunc(status) {
        if (status)
            // Add all meals that don't already exist in selectedMeals
            setSelectedMeals((prevMeals) => {
                const newMeals = meals.filter(
                    (meal) => !prevMeals.some((selectedMeal) => selectedMeal.meal_id === meal.meal_id)
                );
                return [...prevMeals, ...newMeals];
            });
        else
            // Remove only the meals that exist in the 'meals' array from 'selectedMeals'
            setSelectedMeals((prevMeals) =>
                prevMeals.filter(
                    (selectedMeal) => !meals.some((meal) => meal.meal_id === selectedMeal.meal_id)
                )
            );
    }

    function checkMealChecked(meal_tmp) {
        return selectedMeals?.some((meal) => meal.meal_id === meal_tmp.meal_id);
    }

    function checkAllMealChecked() {
        return meals?.every((meal) =>
            selectedMeals.some((selectedMeal) => selectedMeal.meal_id === meal.meal_id)
        );
    }

    async function getAllSelectedMeals() {
        const result = await post('/api/admin/meal/get-all-meals', {
            meal_id_array: selectedMeals.map((meal) => meal.meal_id)
        })
        if (result)
            setSelectedMeals(result)
    }

    async function selectAllMealsInFilter() {
        if (search) {
            // if search
            const response = await post('/api/admin/meal/get-all-meals', { search: search })
            if (response)
                setSelectedMeals(response)
        } else if (filter == 'needs attention') {
            const response = await get('/api/admin/meal/get-meals-needing-review?' + ((filterCuisine && filterCuisine != '-All-') ? ('&cuisine=' + filterCuisine) : ''))

            if (response)
                setSelectedMeals(response)
        } else {
            const condition = getConditions()

            const response = await post('/api/admin/meal/get-all-meals?condition=' + condition)
            if (response)
                setSelectedMeals(response)
        }
    }

    function searchFunc(value) {
        if (value)
            setSearch(` AND m.name ILIKE '%${value}%'`)
        else
            setSearch()
    }

    async function generateMealBasedOnCuisine() {
        const response = await post('/api/admin/meal/generate-meals-based-on-cuisine', { cuisine: 'Arabic', n: 10 })
        console.log(response)
    }


    return (
        <div className='admin_meals'>
            <button onClick={() => generateMealBasedOnCuisine()}>Generate Arabic</button>

            {mealsSelectedAction ? <SelectedMealModal selected_meals={selectedMeals} mealsSelectedAction={mealsSelectedAction}
                setMealsSelectedAction={setMealsSelectedAction} selectedMealFunc={selectedMealFunc} checkMealChecked={checkMealChecked}
                getAllSelectedMeals={getAllSelectedMeals} />
                : null}

            <div className='admin_meals_div'>
                <div className='admin_meals_filter flex gap_8'>
                    <p onClick={() => setFilter('all')} className={filter == 'all' ? 'admin_meals_indiv_filter_selected' : 'admin_meals_indiv_filter'}>All</p>
                    <p onClick={() => setFilter('active')} className={filter == 'active' ? 'admin_meals_indiv_filter_selected' : 'admin_meals_indiv_filter'}>Active</p>
                    <p onClick={() => setFilter('inactive')} className={filter == 'inactive' ? 'admin_meals_indiv_filter_selected' : 'admin_meals_indiv_filter'}>Inactive</p>
                    <p onClick={() => setFilter('subscribers')} className={filter == 'subscribers' ? 'admin_meals_indiv_filter_selected' : 'admin_meals_indiv_filter'}>Subscribers Only</p>
                    <p onClick={() => setFilter('needs attention')} className={filter == 'needs attention' ? 'admin_meals_indiv_filter_attention_selected' : 'admin_meals_indiv_filter_attention'}>Needs Attention</p>
                </div>
                <div className='admin_meals_filter flex gap_8'>
                    <select className='admin_meals_filter_cuisine' onChange={(e) => setFilterCuisine(e.target.value)}>
                        <option value={'-All-'}>-All Cuisines-</option>
                        {cuisines?.map((cuisine, i) => (
                            <option value={cuisine.cuisine_id}>{cuisine.name}</option>
                        ))}
                    </select>
                </div>
                <div className='admin_meals_page_div text_align_center'>
                    <div className='flex gap_6 width_fit_content'>
                        {page > 1 ? <p className='font_size_16 cursor_pointer' onClick={() => setPage(page - 1)}>{'<'}</p> : null}
                        <p className='font_size_16 cursor_default'>{page}</p>
                        {meals && meals.length > 1 ? <p className='font_size_16 cursor_pointer' onClick={() => setPage(page + 1)}>{'>'}</p> : null}
                    </div>
                    <p>page</p>
                </div>

                <div className='flex gap_8'>
                    <button className='admin_meals_select_all_button green_gradient font_size_14 white cursor_pointer' onClick={selectAllMealsInFilter}>Select All</button>
                </div>

                {selectedMeals.length ?
                    <div className='flex flex_column gap_8'>
                        <p>{selectedMeals.length} selected</p>
                        <div className='flex gap_8'>
                            <button className='cursor_pointer' onClick={() => setMealsSelectedAction(true)}>Action</button>
                            <p className='admin_meals_unselect_all cursor_pointer' onClick={() => setSelectedMeals([])}>Unselect</p>
                        </div>
                    </div> : null}

                <input className='add_meal_search_box font_family_inter font_size_14' placeholder='Search Meal...' onChange={(e) => searchFunc(e.target.value)} />

                <div className='flex gap_20 width_100'>
                    <div className={'flex flex_column ' + (!meal ? 'width_100' : '')}>
                        <div className={(!meal ? 'admin_meals_list_indiv_meal' : 'admin_meals_list_indiv_meal_small')}>
                            <input onChange={(e) => selectedAllMealFunc(e.target.checked)} checked={checkAllMealChecked()} type='checkbox' className='admin_meals_list_indiv_meal_checkbox cursor_pointer' />

                            <p className='font_size_16'>Image</p>
                            <p className='font_size_16'>Name</p>
                            {!meal ? <p className='font_size_16'>Cuisine</p> : null}
                            {!meal ? <p className='font_size_16'>Course</p> : null}
                            {!meal ? <p className='font_size_16'>Ingr.</p> : null}
                            {!meal ? <p className='font_size_16'>Recipe</p> : null}
                            {!meal ? <p className='font_size_16'>Status</p> : null}
                            {!meal ? <p className='font_size_16'>Open to</p> : null}
                            {(filter == 'needs attention') ? <p className='font_size_16'>Info</p> : null}
                        </div>
                        {meals?.map((meal_tmp, i) => (
                            <div key={i} className={(!meal ? 'admin_meals_list_indiv_meal' : 'admin_meals_list_indiv_meal_small') + ' admin_meals_list_indiv_meal_' + ((!meal || meal.meal_id != meal_tmp.meal_id) ? i % 2 : 'clicked')}>
                                <input onChange={(e) => selectedMealFunc(meal_tmp, e.target.checked)} checked={checkMealChecked(meal_tmp)} type='checkbox' className='admin_meals_list_indiv_meal_checkbox cursor_pointer' />

                                {meal_tmp.image ? <img src={meal_tmp.image} className='admin_meals_list_indiv_meal_img' /> : <div></div>}

                                <p className='font_size_20 word_break cursor_pointer' onClick={() => mealClicked(meal_tmp.meal_id)}>{meal_tmp.name}</p>

                                {!meal ? <p className='font_size_16 word_break'>{meal_tmp.cuisines}</p> : null}
                                {!meal ? <p className='font_size_16 word_break'>{meal_tmp.courses}</p> : null}
                                {!meal ? <p className='font_size_16 word_break'>{meal_tmp.ingredient_count}</p> : null}
                                {!meal ? <p className='font_size_16 word_break'>{meal_tmp.recipe_count}</p> : null}
                                {!meal ? <p onClick={() => setActiveStatus(meal_tmp.meal_id, !meal_tmp.is_active)} className={'font_size_16 text_align_center cursor_pointer ' + (meal_tmp.is_active ? 'admin_meals_list_indiv_meal_active' : 'admin_meals_list_indiv_meal_inactive')}>
                                    {meal_tmp.is_active ? 'Active' : 'Inactive'}
                                </p> : null}
                                {!meal ? <p onClick={() => setSubStatus(meal_tmp.meal_id, !meal_tmp.subscribers_only)} className={'font_size_16 text_align_center cursor_pointer ' + (meal_tmp.subscribers_only ? 'admin_meals_list_indiv_meal_subscribers' : 'admin_meals_list_indiv_meal_all')}>
                                    {meal_tmp.subscribers_only ? 'Subscribers' : 'All users'}
                                </p> : null}

                                {(filter == 'needs attention') ?
                                    <div className='admin_meals_list_indiv_meal_attention_reason cursor_help white'
                                        data-tooltip-id={meal_tmp.meal_id + "-need-attention-tooltip"} data-tooltip-content={meal_tmp.reason}>i</div>
                                    : null}

                                <Tooltip id={meal_tmp.meal_id + "-need-attention-tooltip"} />
                            </div>
                        ))}
                    </div>

                    {meal ? <AdminIndividualMeal meal={meal} setMeal={setMeal} getMeal={mealClicked} user_data={user_data} /> : null}
                </div>
            </div>
        </div>
    );
}


export default AdminMeals;